import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

//Actions
import {
    addItem
} from '../../actions/item';

import {
    allStatusEffects
} from '../../resources/arrays'
import { current } from '@reduxjs/toolkit';


const initialState = {
    mods: [],
    name: "",
    classification: "",
    type: "Mod",
    subtype: "Simple Mod",
    description: "",
    value: 50,
    rarity: "",
    weight: 1,
    stackable: false,
    buyable: true,
    craftable: false,
    modItem: "",
    modLocation: "",
    modEffects: [],
    skillRequirementName: "Tech",
    skillRequirementLevel: 5,
    recipe: [],
    quantityCrafted: 1
}

const AddItem = ({
    addItem,
    item: { item }
}) => {

    const [currentState, updateCurrentState] = useState(initialState);

    const onChange = e => {
            updateCurrentState({...currentState, [e.target.name]: e.target.value});
    }

    const updateEffect = (effectInd) => e => {
        var curEffObj = currentState.modEffects[effectInd];

        var newEffObj = {...curEffObj, [e.target.name]: e.target.value}

        var newEffects = currentState.modEffects;

        newEffects[effectInd] = newEffObj;

        updateCurrentState({...currentState, "modEffects": newEffects});
    }

    const getModLocationList = () => {
        switch(currentState.modItem){
            case "Gun":
            case "Assault Weapon":
            case "Long Range":
            case "Pistol":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Barrel</option>
                            <option>Magazine</option>
                            <option>Capacitor</option>
                            <option>Barrel</option>
                        </select>
                    </Fragment>
                )
            case "Melee":
            case "Blade":
            case "Blunt":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Grip</option>
                            <option>Material</option>
                            <option>Surface</option>
                            <option>Misc.</option>
                        </select>
                    </Fragment>
                )
            case "Body":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Front</option>
                            <option>Back</option>
                            <option>Coating</option>
                            <option>Material</option>
                        </select>
                    </Fragment>
                )
            case "Helmet":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Visor</option>
                            <option>Accessory</option>
                            <option>Coating</option>
                            <option>Material</option>
                        </select>
                    </Fragment>
                )
            case "Gloves":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Palm</option>
                            <option>Back</option>
                            <option>Wrist</option>
                            <option>Material</option>
                        </select>
                    </Fragment>
                )
            case "Boots":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Sole</option>
                            <option>Ankle</option>
                            <option>Coating</option>
                            <option>Material</option>
                        </select>
                    </Fragment>
                )
            case "Vehicle":
                return (
                    <Fragment>
                        <label className="text-light1">Mod Location</label>
                        <select id="item-subtype" className="hmp" name="modLocation" onChange={onChange} defaultValue={!currentState.modLocation ? '-- pick one --' : currentState.modLocation}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>Engine</option>
                            <option>Frame</option>
                            <option>Storage</option>
                            <option>Material</option>
                        </select>
                    </Fragment>
                );
            default:
                return(
                    <Fragment>
                        <p>Please select a mod item first!</p>
                    </Fragment>
                );
        }
    }

    const getEffectList = (ind) => {
        switch(currentState.modEffects[ind].effectTarget){
            case "Skill Roll":
            case "Attack Roll":
            case "Saving Throw":
                return (
                    <Fragment>
                    <select id="item-effectTarget" className="hmp" name="effect" onChange={e => updateEffect(ind)(e)} defaultValue={!currentState.modEffects[ind].effect ? '-- pick one --' : currentState.modEffects[ind].effect}>
                        <option disabled selected style={{display:'none'}}> -- pick one --</option>
                        <option>Roll Mod</option>
                        <option>Advantage</option>
                        <option>Disadvantage</option>
                    </select>
                    {
                    currentState.modEffects[ind].effect === "Roll Mod" && 
                        <select id="item-effectTarget" className="hmp" name="value" onChange={e => updateEffect(ind)(e)} defaultValue={!currentState.modEffects[ind].value ? '-- pick one --' : currentState.modEffects[ind].value}>
                            <option disabled selected style={{display:'none'}}> -- pick one --</option>
                            <option>-5</option>
                            <option>-4</option>
                            <option>-3</option>
                            <option>-2</option>
                            <option>-1</option>
                            <option>0</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                        </select>
                    }
                    </Fragment>
                );
            case "Damage Roll":
                return (
                    <select id="item-effectTarget" className="hmp" name="effect" onChange={e => updateEffect(ind)(e)} defaultValue={!currentState.modEffects[ind].effect ? '-- pick one --' : currentState.modEffects[ind].effect}>
                        <option disabled selected style={{display:'none'}}> -- pick one --</option>
                        <option>1d4</option>
                        <option>2d4</option>
                        <option>3d4</option>
                        <option>1d6</option>
                        <option>2d6</option>
                        <option>3d6</option>
                        <option>1d8</option>
                        <option>2d8</option>
                        <option>3d8</option>
                    </select>
                );
            case "DIS":
            case "KIN":
            case "Movement":
            case "Carrying Capacity":
                return (
                    <select id="item-effectTarget" className="hmp" name="effect" onChange={e => updateEffect(ind)(e)} defaultValue={!currentState.modEffects[ind].effect ? '-- pick one --' : currentState.modEffects[ind].effect}>
                        <option disabled selected style={{display:'none'}}> -- pick one --</option>
                        <option>2</option>
                        <option>4</option>
                        <option>6</option>
                        <option>8</option>
                        <option>10</option>
                        <option>12</option>
                        <option>14</option>
                        <option>16</option>
                        <option>18</option>
                        <option>20</option>
                        <option>22</option>
                        <option>24</option>
                        <option>26</option>
                        <option>28</option>
                        <option>30</option>
                    </select>
                );
            case "Immunity":
            case "Resistance":
            case "Weakness":
                return (
                    <select id="item-effectTarget" className="hmp" name="effect" onChange={e => updateEffect(ind)(e)} defaultValue={!currentState.modEffects[ind].effect ? '-- pick one --' : currentState.modEffects[ind].effect}>
                        <option disabled selected style={{display:'none'}}> -- pick one --</option>
                        {
                            allStatusEffects.map((eff, index) => {
                                <option key={index}>{eff}</option>
                            })
                        }
                    </select>
                );
            default:
                return (
                    <div>Please select an effect target first!</div>
                )
        }
    }

    const getCurrentEffects = () => {
        const effectEle = currentState.modEffects.map((eff, index) => 
            <div key={index}>
                <h2 className="text-orange">Effect {index + 1}</h2>
                <select id="item-effectTarget" className="hmp" name="effectTarget" onChange={e => updateEffect(index)(e)} defaultValue={!currentState.modEffects[index].effectTarget ? '-- pick one --' : currentState.modEffects[index].effectTarget}>
                    <option disabled selected style={{display:'none'}}> -- pick one --</option>
                    <option>Skill Roll</option>
                    <option>Attack Roll</option>
                    <option>Damage Roll</option>
                    <option>Saving Throw</option>
                    <option>DIS</option>
                    <option>KIN</option>
                    <option>Movement</option>
                    <option>Carrying Capacity</option>
                    <option>Immunity</option>
                    <option>Resistance</option>
                    <option>Weakness</option>
                    <option>Add Action</option>
                </select>
                <div className="text-light1">
                    {getEffectList(index)}
                </div>
                
            </div>
        )

        return effectEle;
    }

    const addEffect = () => e => {


        var newEffect = {
            "effectTarget": "",
            "effect": "",
            "value": 0
        }

        updateCurrentState({
            ...currentState,
            "modEffects": [...currentState.modEffects, newEffect]
        })
    }

    const saveItemToDB = e => {
        if(currentState.name === ""){
            alert("Please give the item a name");
            return;
        }
        if(currentState.description === ""){
            alert("Please give the item a description");
            return;
        }
        if(currentState.modItem === ""){
            alert("Please select an item to mod");
            return;
        }
        if(currentState.modLocation === ""){
            alert("Please select mod location");
            return;
        }
        if(currentState.modEffects.length === 0){
            alert("Please add at least one effect");
            return;
        }
        if(currentState.modEffects[0].effectTarget === ""){
            alert("First effect needs a target");
            return;
        }
        if(currentState.modEffects[0].effect === ""){
            alert("First effect needs a selected effect");
            return;
        }

        console.log("Ready to add item");


        //addItem(currentState);
    }

    console.log(currentState);

    return (<Fragment>
        <div className="addItemForm">
            <h1 className="text-orange mary-2">Add Mod to DB</h1>
            <label className="text-light1">Item Name: </label><input className="mary-1 pad-1" type="text" id="item-name" name="name" onChange={onChange} value={currentState.name}/><br />
            <label className="text-light1" for="description">Description: </label><textarea className="info-container pad-1" name='description' value={currentState.description} cols="75" rows="6" onChange={onChange}></textarea><br />
            <label className="text-light1 mary-1">Item to Mod: </label>
            <select id="item-modItem" className="hmp mary-1" name="modItem" onChange={onChange} defaultValue={!currentState.modItem ? '-- pick one --' : currentState.modItem}>
                <option disabled selected style={{display:'none'}}> -- pick one --</option>
                <option>Gun</option>
                <option>Melee</option>
                <option>Armor</option>
                <option>Vehicle</option>
            </select>
            {getModLocationList()}
            <h1 className="addEffectBut text-blue" onClick={e => addEffect()(e)}>Add Effect</h1>
            <div className="effectList">
                {getCurrentEffects()}
            </div>
            <div>
                <div className="btn mary-2" onClick={saveItemToDB}>SUBMIT</div>
            </div>
        </div>
    </Fragment>)
}

AddItem.propTypes = {
    addItem: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    item: state.item
});

export default connect(mapStateToProps, { addItem })(AddItem);